import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { blackBackground } from '../../../../constants/color';
export const WidgetHeader = ({ children, background = blackBackground, padding = '15px 25px', direction = 'row', height = '80px', minHeight, }) => {
    return (_jsx(Box, { sx: {
            display: 'flex',
            gap: direction === 'column' ? 0 : 1,
            background: background,
            flexDirection: direction,
            justifyContent: direction === 'column' ? 'center' : 'space-between',
            alignItems: direction === 'column' ? 'flex-start' : 'center',
            borderRadius: '25px 25px 0px 0px',
            padding: padding,
            height,
            minHeight
        }, children: children }));
};
